import notification from '@/api/notification'

const getDefaultState = () => ({
    isLoading: false,
    notifications: []
})

export default {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        isLoading(state) {
            return state.isLoading
        },
        notifications(state) {
            return state.notifications
        }
    },
    mutations: {
        setIsLoading(state, { value }) {
            state.isLoading = value
        },
        resetNotifications(state) {
            state.notifications = []
        },
        updateNotifications(state, { results }) {
            state.notifications = results
        },
        addNewNotification(state, { notification }) {
            state.notifications = [notification, ...state.notifications]
        }
    },
    actions: {
        async getAllNotifications({commit}, payload) {
            commit('resetNotifications')
            commit('setIsLoading', {value: true})
            return await notification.getAllNotifications(payload.limit, payload.offset)
        },
        async setIsViewedNotifications({commit}, pk) {
            commit('setIsLoading', {value: true})
            return await notification.setIsViewedNotifications(pk)
        },
        async setIsViewedAllNotifications({commit}) {
            commit('setIsLoading', {value: true})
            return await notification.setIsViewedAllNotifications()
        },
        async setIsDeleteNotification({commit}, pk) {
            commit('setIsLoading', {value: true})
            return await notification.setIsDeleteNotification(pk)
        }
    }
}
